import {Injectable, inject} from '@angular/core';
import {Haptics} from '@capacitor/haptics';
import {ImpactStyle} from '@capacitor/haptics/dist/esm/definitions';
import {SystemInfoService} from '../system-info/system-info.service';

@Injectable({
    providedIn: 'root'
})
export class HapticsService {
    private readonly systemInfoService = inject(SystemInfoService);

    public async hapticsMedium(): Promise<void> {
        if (this.systemInfoService.isCapacitor()) {
            await Haptics.impact({
                style: ImpactStyle.Medium,
            });
        }
    }

    public async hapticsHeavy(): Promise<void> {
        if (this.systemInfoService.isCapacitor()) {
            await Haptics.impact({
                style: ImpactStyle.Heavy,
            });
        }
    }
}
